import emptySliceApi from '../../shared/store/emptyApiSlice';
import { EnrollmentLogQueryResult, LogQueryResult } from './models';

export interface LogApiRequest {
  accountId: string;
  logType: string;
  continuationToken?: string;
}

export interface LogSearchApiRequest {
  accountId?: string;
  logType?: string;
  continuationToken?: string;
  id?: string;
  startDate?: string;
  endDate?: string;
  action?: string;
  user?: string;
  search?: string;
  searchField?: string;
  errorMessage?: string;
  accountUser?: string;
}

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    getEnrollmentLogs: builder.query<
      EnrollmentLogQueryResult,
      { accountId: string; continuationToken: string }
    >({
      query: ({ accountId, continuationToken }) =>
        `v4/accounts/${accountId}/orders${
          continuationToken ? `?continuationToken=${continuationToken}` : ''
        }`,
    }),
    getLogs: builder.query<
      LogQueryResult,
      { accountId: string; search: LogSearchApiRequest }
    >({
      query: ({ accountId, search }) => {
        const query = [];
        // eslint-disable-next-line guard-for-in,no-restricted-syntax
        for (const k in search) {
          if (k !== 'accountId') {
            query.push(`${k}=${search[k]}`);
          }
        }
        return `v4/accounts/${accountId}/logs/search?${query.join('&')}`;
      },
    }),
  }),
  overrideExisting: true,
});

export const { useGetLogsQuery, useGetEnrollmentLogsQuery } = apiSlice;
